/* A3DP sticky add-to-cart bar — product pages only.
   Syncs price/variant from Dawn's own form (single source of truth);
   shows once the main buy block scrolls out of view. */
(function () {
  'use strict';
  var bar = document.querySelector('.a3dp-atcbar');
  if (!bar) return;

  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  var anchor = document.querySelector('.product-form__buttons') || form;
  var titleEl = bar.querySelector('.a3dp-atcbar__title');
  var priceEl = bar.querySelector('.a3dp-atcbar__price');
  var stockEl = bar.querySelector('.a3dp-atcbar__stock');
  var btn = bar.querySelector('.a3dp-atcbar__btn');
  var idInput = form.querySelector('.product-variant-id');

  var productName =
    (titleEl && titleEl.dataset.name) ||
    (document.querySelector('.product__title h1') || {}).textContent ||
    '';
  if (titleEl) titleEl.textContent = productName.trim();

  function priceText() {
    var priceBlock = document.querySelector('.product__info-container .price');
    if (!priceBlock) return '';
    var item = priceBlock.querySelector('.price-item--last, .price-item--regular, .price-item--sale');
    return item ? item.textContent.trim() : '';
  }

  function stockState() {
    var btnMain = document.querySelector('.product-form__submit');
    if (!btnMain) return { soldout: false, label: '' };
    var soldout = btnMain.hasAttribute('disabled');
    var label = soldout ? 'SOLD OUT' : 'IN STOCK';
    var inv = document.querySelector('.product__inventory');
    if (!soldout && inv && inv.textContent.trim()) {
      var t = inv.textContent.trim();
      if (/sold out/i.test(t)) { soldout = true; label = 'SOLD OUT'; }
      else if (/in stock/i.test(t)) { label = 'IN STOCK'; }
      else if (t.length < 40) { label = t.toUpperCase(); }
    }
    return { soldout: soldout, label: label };
  }

  function sync() {
    if (priceEl) priceEl.textContent = priceText() || priceEl.textContent;
    var st = stockState();
    if (stockEl) {
      stockEl.textContent = st.label;
      stockEl.classList.toggle('is-soldout', st.soldout);
    }
    if (btn) {
      if (st.soldout) btn.setAttribute('disabled', 'disabled');
      else btn.removeAttribute('disabled');
      btn.textContent = st.soldout ? 'Sold out' : 'Add to cart';
    }
  }

  if (idInput) {
    new MutationObserver(sync).observe(idInput, { attributes: true, attributeFilter: ['value', 'disabled'] });
  }
  var priceBlock = document.querySelector('.product__info-container .price');
  if (priceBlock) {
    new MutationObserver(sync).observe(priceBlock, { subtree: true, childList: true, characterData: true });
  }
  var invEl = document.querySelector('.product__inventory');
  if (invEl) {
    new MutationObserver(sync).observe(invEl, { subtree: true, childList: true, characterData: true });
  }

  if ('IntersectionObserver' in window && anchor) {
    var io = new IntersectionObserver(
      function (entries) {
        var visible = entries.some(function (e) { return e.isIntersecting; });
        var live = bar.classList.toggle('is-visible', !visible);
        document.body.classList.toggle('a3dp-atcbar-live', live);
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    io.observe(anchor);
  }

  if (btn) {
    btn.addEventListener('click', function () {
      if (btn.hasAttribute('disabled')) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
      else form.submit();
    });
  }

  sync();
})();
